export default __webpack_public_path__ + "static/media/runway_light.3b27b953.png";